/* ============ SCROLL MOOD — atmospheric glow drift ============
 * IntersectionObserver over the home page's top-level sections
 * (marked with [data-mood-section]) sets --mood-progress (0=dawn..1=dusk) on
 * <body>. mood.css uses that value to blend --mood-glow-dawn ->
 * --mood-glow-day -> --mood-glow-dusk via color-mix() into a subtle
 * background wash. Inert (fixed mid-tone, no drift) under
 * prefers-reduced-motion: reduce.
 */

function initScrollMood() {
  const sections = document.querySelectorAll('[data-mood-section]');
  if (!sections.length) return; // No-op on pages without mood sections.

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.body.style.setProperty('--mood-progress', '0.5');
    return;
  }

  const total = sections.length;
  const progressBySection = new Map();
  sections.forEach((section, index) => {
    progressBySection.set(section, total > 1 ? index / (total - 1) : 0);
  });

  const observer = new IntersectionObserver(
    (entries) => {
      let best = null;
      for (const entry of entries) {
        if (entry.isIntersecting && (!best || entry.intersectionRatio > best.intersectionRatio)) {
          best = entry;
        }
      }
      if (best) {
        const progress = progressBySection.get(best.target);
        document.body.style.setProperty('--mood-progress', String(progress));
      }
    },
    { threshold: [0.25, 0.5, 0.75] }
  );

  sections.forEach((section) => observer.observe(section));
}

export { initScrollMood };
